import { render, staticRenderFns } from "./BotiIntro.vue?vue&type=template&id=138bcc90&scoped=true&"
import script from "./BotiIntro.vue?vue&type=script&lang=js&"
export * from "./BotiIntro.vue?vue&type=script&lang=js&"
import style0 from "./BotiIntro.vue?vue&type=style&index=0&id=138bcc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138bcc90",
  null
  
)

export default component.exports